import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);
let shortcutsMap = undefined;
function getRecentMonth (num) {
    return {
        startTime: dayjs().subtract(1, 'day').subtract(num, 'month').startOf('month').format('YYYY-MM-DD'),
        endTime: dayjs().subtract(1, 'day').month() !== dayjs().month() ? dayjs().format('YYYY-MM-DD') : dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
        text: `最近${num + 1}月`
    };
}
const shortcutsMapFactory = () => ({
    '默认时间': { text: '默认时间', startTime: '', endTime: '' },
    '今天': { text: '今天', startTime: dayjs().format('YYYY-MM-DD'), endTime: dayjs().format('YYYY-MM-DD') },
    '昨天': { text: '昨天', startTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD') },
    '本周': { text: '本周', startTime: dayjs().startOf('isoWeek').format('YYYY-MM-DD'), endTime: dayjs().format('YYYY-MM-DD') },
    '上周': { text: '上周', startTime: dayjs().subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD') },
    '最近7天': { text: '最近7天', startTime: dayjs().subtract(7, 'day').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD') },
    '7天内': { text: '7天内', startTime: dayjs().subtract(6, 'day').format('YYYY-MM-DD'), endTime: dayjs().format('YYYY-MM-DD') },
    '最近14天': { text: '最近14天', startTime: dayjs().subtract(14, 'day').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD') },
    '14天内': { text: '14天内', startTime: dayjs().subtract(13, 'day').format('YYYY-MM-DD'), endTime: dayjs().format('YYYY-MM-DD') },
    '最近30天': { text: '最近30天', startTime: dayjs().subtract(30, 'day').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD') },
    '30天内': { text: '30天内', startTime: dayjs().subtract(29, 'day').format('YYYY-MM-DD'), endTime: dayjs().format('YYYY-MM-DD') },
    '最近90天': { text: '最近90天', startTime: dayjs().subtract(90, 'day').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD') },
    '最近180天': { text: '最近180天', startTime: dayjs().subtract(180, 'day').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD') },
    '最近360天': { text: '最近360天', startTime: dayjs().subtract(360, 'day').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'day').format('YYYY-MM-DD') },
    '上月': { text: '上月', startTime: dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD') },
    '本月': { text: '本月', startTime: dayjs().startOf('month').format('YYYY-MM-DD'), endTime: dayjs().format('YYYY-MM-DD') },
    '当月': { text: '当月', startTime: dayjs().startOf('month').format('YYYY-MM-DD'), endTime: +dayjs().startOf('month') === +dayjs() ? dayjs().format('YYYY-MM-DD') : dayjs().subtract(1, 'day').format('YYYY-MM-DD') },
    '近3月': { text: '近3月', startTime: dayjs().subtract(3, 'month').startOf('month').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD') },
    '最近3月': getRecentMonth(2),
    '近6月': { text: '近6月', startTime: dayjs().subtract(6, 'month').startOf('month').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD') },
    '最近6月': getRecentMonth(5),
    '近12月': { text: '近12月', startTime: dayjs().subtract(12, 'month').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'month').format('YYYY-MM-DD') },
    '最近12月': getRecentMonth(11),
    '当前季度': { text: '当前季度', startTime: dayjs().subtract((dayjs().month()) % 3, 'month').startOf('month').format('YYYY-MM-DD'), endTime: (() => {
        let end = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        if (dayjs().date() === 1 && [0, 3, 6, 9].includes(dayjs().month())) {
            end = dayjs().format('YYYY-MM-DD');
        }
        return end;
    })() },
    '本季度': {
        text: '本季度',
        starttime: dayjs().subtract((dayjs().month()) % 3, 'month').startOf('month').format('YYYY-MM-DD'),
        endTime: dayjs().add((dayjs().month() + 2) % 3, 'month').endOf('month').format('YYYY-MM-DD')
    },
    '上季度': { text: '上季度', ...(() => {
        const month = (dayjs().subtract(3, 'month').month()) % 3;
        const startTime = dayjs().subtract(month + 3, 'month').startOf('month').format('YYYY-MM-DD');
        const endTime = dayjs().subtract(month + 1, 'month').endOf('month').format('YYYY-MM-DD');
        return { startTime, endTime };
    })()},
    '今年': { text: '今年', startTime: dayjs().startOf('year').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'month').format('YYYY-MM-DD') },
    '当年': { text: '当年', startTime: dayjs().startOf('year').format('YYYY-MM-DD'), endTime: (() => {
        let end = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
        if (dayjs().format('MM-DD') === '01-01') {
            end = dayjs().format('YYYY-MM-DD');
        }
        return end;
    })() },
    '去年': { text: '去年', startTime: dayjs().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'), endTime: dayjs().subtract(1, 'year').endOf('year').format('YYYY-MM-DD') },
    '素材默认': { text: '素材默认', startTime: dayjs().subtract(43, 'day').format('YYYY-MM-DD'), endTime: dayjs().subtract(14, 'day').format('YYYY-MM-DD') },
});

function getShortcuts (timeList = [], customShortcuts) {
    if (!timeList || timeList.length === 0) {
        return [];
    }
    shortcutsMap = {
        ...shortcutsMapFactory(),
        ...customShortcuts
    };
    return timeList.map(name => {
        const { startTime, starttime, endTime, endtime, text } = shortcutsMap[name] || {};
        return {
            text,
            onClick: picker => picker.$emit('pick', [startTime || starttime, endTime || endtime])
        };
    });
};

function getQuickTime (start, end) {
    shortcutsMap = shortcutsMap || shortcutsMapFactory();
    if (start && end) {
        const timerangeStr = `${dayjs(start).format('YYYY-MM-DD')}${dayjs(end).format('YYYY-MM-DD')}`;
        for (const key in shortcutsMap) {
            const { startTime, starttime, endTime, endtime, text } = shortcutsMap[key];
            const st = startTime || starttime, ed = endTime || endtime
            if (`${st}${ed}` === timerangeStr) return text;
        }
    }
};

export {
    getShortcuts,
    getQuickTime
};
